import { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export default function NavigationProgress() {
  const location = useLocation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const prevPathname = useRef(location.pathname);
  const timersRef = useRef([]);

  const clearTimers = useCallback(() => {
    timersRef.current.forEach(clearTimeout);
    timersRef.current = [];
  }, []);

  useEffect(() => {
    if (prevPathname.current === location.pathname) return;
    prevPathname.current = location.pathname;

    clearTimers();

    // Start the progress bar
    setVisible(true);
    setProgress(15);

    timersRef.current.push(
      setTimeout(() => setProgress(45), 80),
      setTimeout(() => setProgress(75), 200),
      setTimeout(() => setProgress(100), 350),
      setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 600)
    );

    return clearTimers;
  }, [location.pathname, clearTimers]);

  if (!visible && progress === 0) return null;

  return (
    <div className="nav-progress-track">
      <div
        className="nav-progress-bar"
        style={{
          transform: `scaleX(${progress / 100})`,
          opacity: progress >= 100 ? 0 : 1,
        }}
      />
    </div>
  );
}
